/** FAQ, Support, and Advertising page copy (Russian translation). */
export const pagesMessagesRu = {
  faq: {
    pageTitle: "Часто задаваемые вопросы",
    pageSubtitle: "Найдите ответы на распространённые вопросы о WasOK",
    seoTitle: "Частые вопросы — WasOK",
    seoDescription:
      "Ответы на частые вопросы о WasOK, сканировании товаров, конфиденциальности и оценках.",
    items: [
      {
        question: "Как работает WasOK?",
        answer:
          "WasOK помогает вам помнить, какие товары вам понравились или не понравились, сканируя штрихкоды и сохраняя ваши оценки и заметки. Просто отсканируйте штрихкод товара, оцените его, добавьте заметки, и в следующий раз, отсканировав тот же товар, вы сразу увидите свой предыдущий отзыв.",
      },
      {
        question: "Хранятся ли мои данные в облаке?",
        answer:
          "Нет! Все ваши данные хранятся локально на вашем устройстве. Мы не синхронизируем вашу информацию с облаком, а значит, история покупок и мнения о товарах остаются полностью приватными. Однако это также означает, что вам стоит делать резервную копию устройства, если вы хотите сохранить данные.",
      },
      {
        question: "Нужно ли интернет-соединение для использования WasOK?",
        answer:
          "Нет, WasOK полностью работает офлайн. Поскольку все данные хранятся локально на устройстве, вы можете сканировать товары, добавлять оценки и просматривать историю без какого-либо интернет-соединения.",
      },
      {
        question: "Могу ли я использовать WasOK для любого типа товаров?",
        answer:
          "Да! WasOK работает с любым товаром, у которого есть штрихкод. Будь то еда, косметика, товары для дома, электроника или что-либо ещё со штрихкодом — вы можете отсканировать это и сохранить своё мнение.",
      },
      {
        question: "Как отсканировать штрихкод?",
        answer:
          "Просто откройте приложение WasOK и нажмите кнопку сканирования. Наведите камеру на штрихкод товара, и приложение автоматически распознает и отсканирует его. Для лучшего результата убедитесь, что штрихкод хорошо освещён и в фокусе.",
      },
      {
        question: "Могу ли я добавлять фото к отзывам о товарах?",
        answer:
          "Да! Вы можете прикреплять фото к любому отзыву о товаре. Это особенно полезно, чтобы запомнить детали упаковки, список ингредиентов или другую визуальную информацию, которая поможет вспомнить, почему товар понравился или не понравился.",
      },
      {
        question: "Какую информацию я могу сохранять о товарах?",
        answer:
          "Вы можете сохранять оценки (от 1 до 5 звёзд), текстовые заметки, фото, цену, которую заплатили, место покупки и собственные категории. Эта подробная информация помогает принимать взвешенные решения при покупках.",
      },
      {
        question: "Могу ли я создавать списки покупок?",
        answer:
          "Да! WasOK позволяет создавать списки покупок из товаров, которые вы уже оценили. Это упрощает запоминание того, какие товары вам понравились и которые вы хотите купить снова.",
      },
      {
        question: "Как организовать мои товары?",
        answer:
          "Вы можете организовывать товары с помощью собственных категорий. Например, вы можете создать категории «Снеки», «Кофе», «Уход за кожей» или «Средства для уборки». Это упрощает просмотр отзывов по типу.",
      },
      {
        question: "Бесплатен ли WasOK?",
        answer:
          "Да, WasOK полностью бесплатен для загрузки и использования. Нет никаких покупок внутри приложения, подписок или скрытых платежей. Мы верим, что у каждого должен быть доступ к приватному способу запоминать свои предпочтения по товарам.",
      },
      {
        question: "Доступен ли WasOK для людей с ограниченными возможностями?",
        answer:
          "WasOK разработан так, чтобы им могло пользоваться как можно больше людей. Приложение включает функции доступности, такие как поддержка программ чтения с экрана, масштабируемый текст и опциональный режим высокой контрастности.",
      },
      {
        question: "Что произойдёт, если я удалю приложение?",
        answer:
          "Поскольку все данные хранятся локально на устройстве, удаление приложения удалит все ваши отзывы о товарах, заметки и списки покупок. Обязательно экспортируйте данные, если хотите сохранить резервную копию перед удалением.",
      },
      {
        question: "Могу ли я экспортировать свои данные?",
        answer:
          "Да, WasOK позволяет экспортировать данные для резервного копирования. Вы можете экспортировать все свои отзывы в файл, который можно сохранить на устройстве или в облачном хранилище по вашему выбору.",
      },
      {
        question: "Отслеживает ли WasOK моё местоположение?",
        answer:
          "Нет, WasOK не отслеживает ваше местоположение. Хотя вы можете вручную указать название магазина, где купили товар, приложение не использует GPS или службы геолокации.",
      },
      {
        question: "Могу ли я использовать WasOK на нескольких устройствах?",
        answer:
          "На данный момент WasOK не синхронизируется между устройствами, поскольку все данные хранятся локально. У каждого устройства будет своя собственная отдельная база товаров и отзывов.",
      },
      {
        question: "Что делать, если штрихкод не сканируется?",
        answer:
          "Если штрихкод не сканируется, убедитесь, что он хорошо освещён и в фокусе. Также можно попробовать протереть объектив камеры. Если штрихкод повреждён или нечёткий, вы можете ввести номер штрихкода вручную.",
      },
    ],
    cta: {
      heading: "Остались вопросы?",
      body: "Свяжитесь с нашей службой поддержки — мы всегда рады помочь.",
      button: "Связаться с поддержкой",
    },
  },
  support: {
    pageTitle: "Поддержка",
    seoTitle: "Поддержка — WasOK",
    seoDescription:
      "Получите помощь по WasOK: свяжитесь с поддержкой, сообщите об ошибке, поделитесь отзывом.",
    getHelp: {
      title: "Получить помощь",
      body: "Мы здесь, чтобы помочь вам получить максимум от WasOK. Если у вас возникли проблемы или вопросы, у нас есть несколько ресурсов, которые помогут вам.",
    },
    faq: {
      title: "Часто задаваемые вопросы",
      body: "Прежде чем обращаться к нам, загляните в раздел частых вопросов, где мы отвечаем на самые распространённые вопросы о WasOK. Там вы найдёте подробную информацию о работе приложения, конфиденциальности, хранении данных и многом другом.",
    },
    contact: {
      title: "Связаться с поддержкой",
      body: "Если вы не нашли ответ на свой вопрос, наша служба поддержки готова помочь. Вы можете связаться с нами по адресу:",
      emailLabel: "Email:",
      responseTime: "Обычно мы отвечаем в течение 24-48 часов",
    },
    bugs: {
      title: "Сообщить об ошибке",
      body: "Нашли ошибку? Мы ценим вашу помощь в улучшении WasOK. При сообщении об ошибке, пожалуйста, укажите:",
      items: [
        "Подробное описание проблемы",
        "Шаги для воспроизведения проблемы",
        "Модель вашего устройства и версию Android",
        "Скриншоты или запись экрана, если это возможно",
      ],
      sendPrefix: "Отправляйте сообщения об ошибках на:",
    },
    featureRequests: {
      title: "Предложения по функциям",
      bodyBefore: "Есть идея новой функции? Мы будем рады услышать вас! Отправляйте свои предложения на",
      bodyAfter:
        ". Хотя мы не можем реализовать каждый запрос, мы внимательно учитываем все отзывы при планировании будущих обновлений.",
    },
    knownIssues: {
      title: "Известные проблемы",
      body: "Нам известно о следующих проблемах, и мы работаем над их устранением:",
      items: [
        "Некоторые штрихкоды могут не сканироваться при слабом освещении — попробуйте использовать фонарик",
        "Сохранение очень длинных заметок о товарах может занять некоторое время на старых устройствах",
        "Миниатюры изображений могут выглядеть пиксельными на дисплеях высокого разрешения",
      ],
    },
    appUpdates: {
      title: "Обновления приложения",
      body: "Мы регулярно выпускаем обновления с новыми функциями, улучшениями и исправлениями ошибок. Обязательно обновляйте WasOK через Google Play Store, чтобы получать последние улучшения.",
    },
    community: {
      title: "Сообщество",
      body: "Присоединяйтесь к сообществу пользователей, которые принимают более разумные решения о покупках с WasOK. Делитесь советами, задавайте вопросы и общайтесь с другими пользователями в наших социальных каналах.",
    },
    emergency: {
      title: "Экстренная поддержка",
      body: 'Если у вас возникла критическая проблема, которая мешает использовать приложение, пожалуйста, отметьте письмо как «СРОЧНО» в теме, и мы отдадим приоритет вашему запросу.',
    },
    cta: {
      heading: "Всё ещё нужна помощь?",
      body: "Наша служба поддержки всегда рядом. Не стесняйтесь обращаться с любыми вопросами или проблемами.",
      button: "Написать в поддержку",
    },
  },
  advertising: {
    pageTitle: "Реклама и монетизация",
    seoTitle: "Реклама — WasOK",
    seoDescription: "Как WasOK подходит к рекламе и монетизации.",
    approach: {
      title: "Наш подход",
      body: "В WasOK мы считаем, что ваши покупательские привычки и мнения о товарах — это приватная и личная информация. Наша бизнес-модель отражает эту базовую ценность.",
    },
    noAds: {
      title: "Без рекламы",
      body: "WasOK не показывает никакой рекламы. Мы никогда не будем показывать вам рекламу на основе товаров, которые вы сканируете, оценок, которые вы ставите, или любых других данных, созданных вами в приложении. Ваш опыт использования WasOK полностью свободен от рекламы.",
    },
    noDataSelling: {
      title: "Без продажи данных",
      body: "Мы не продаём, не сдаём в аренду и не передаём ваши данные рекламодателям, брокерам данных или каким-либо третьим лицам. Поскольку все ваши данные хранятся локально на устройстве, у нас даже нет к ним доступа. Ваши отзывы о товарах, списки покупок и заметки принадлежат только вам.",
    },
    noTracking: {
      title: "Без отслеживания",
      body: "WasOK не использует трекинговые пиксели, аналитические сервисы или любые другие технологии, которые отслеживают ваше поведение или передают информацию третьим лицам. Мы не отслеживаем, какие товары вы сканируете, в каких магазинах вы делаете покупки или как вы используете приложение.",
    },
    sustainability: {
      title: "Как мы остаёмся устойчивыми",
      body: "Вам может быть интересно, как мы поддерживаем WasOK бесплатным без рекламы и продажи данных. Наш подход прост:",
      items: [
        {
          label: "Бесплатно и открыто:",
          text: "WasOK бесплатен для всех, без премиум-уровней и платных ограничений",
        },
        {
          label: "Экономичная работа:",
          text: "Мы держим расходы низкими, создавая эффективное программное обеспечение, ориентированное на конфиденциальность",
        },
        {
          label: "Добровольные пожертвования:",
          text: "Пользователи, которые любят WasOK, могут поддержать нас добровольными пожертвованиями",
        },
        {
          label: "Открытый исходный код:",
          text: "Мы можем предлагать консультационные услуги или разработку на заказ для организаций",
        },
      ],
    },
    noAffiliate: {
      title: "Без партнёрских ссылок",
      body: "WasOK не использует партнёрские ссылки и не получает комиссии от розничных продавцов. Когда вы сканируете товар, мы не перенаправляем вас куда-либо для покупки. Приложение предназначено исключительно для личного учёта и принятия решений.",
    },
    noPromotions: {
      title: "Без продвижения товаров",
      body: "Мы не принимаем оплату от брендов или производителей за продвижение их товаров. WasOK никогда не будет предлагать товары, выделять определённые бренды или влиять на ваши оценки каким-либо образом. Ваши мнения — только ваши.",
    },
    partnerships: {
      title: "Партнёрства с третьими лицами",
      body: "WasOK не сотрудничает с маркетинговыми компаниями, агрегаторами данных или рекламными сетями. Мы работаем независимо и ставим вашу конфиденциальность превыше всего.",
    },
    future: {
      title: "Планы на будущее",
      body: "Мы стремимся сохранить WasOK свободным от рекламы и ориентированным на конфиденциальность. Если нам когда-либо потребуется внедрить устойчивую бизнес-модель в будущем, мы:",
      items: [
        "Заранее объявим о любых изменениях",
        "Никогда не пойдём на компромисс в вопросах конфиденциальности или безопасности данных",
        "Всегда будем предлагать способ использовать приложение без отслеживания или рекламы",
        "Будем прислушиваться к отзывам и опасениям пользователей",
      ],
    },
    supporting: {
      title: "Поддержка WasOK",
      body: "Если вам нравится WasOK и вы хотите поддержать нашу миссию по созданию приватной памяти о покупках, вы можете:",
      items: [
        "Рассказать друзьям и семье о приложении",
        "Оставить положительный отзыв в Google Play Store",
        "Поделиться с нами своими отзывами и предложениями",
        "Рассмотреть возможность добровольного пожертвования (когда будет доступно)",
      ],
    },
    cta: {
      heading: "Вопросы о наших правилах?",
      body: "Мы прозрачны в том, как работает WasOK. Если у вас есть вопросы о нашем подходе к конфиденциальности, монетизации или устойчивости, пожалуйста, свяжитесь с нами.",
      button: "Связаться с нами",
    },
  },
};
